import React from "react";
import { Tag } from "antd";

// Maps a status string to { color, label, dot } used consistently across the app.
const STATUS_MAP = {
  present: { color: "#14B8A6", bg: "#ECFDF9", label: "Present" },
  late: { color: "#F59E0B", bg: "#FFFBEB", label: "Late" },
  half_day: { color: "#F59E0B", bg: "#FFFBEB", label: "Half Day" },
  on_leave: { color: "#8B5CF6", bg: "#F5F3FF", label: "On Approved Leave" },
  wfh: { color: "#3B82F6", bg: "#EFF6FF", label: "Work From Home" },
  outside_geofence: { color: "#EF4444", bg: "#FEF2F2", label: "Attention Needed" },
  auto_logged_out: { color: "#EF4444", bg: "#FEF2F2", label: "Auto Logged Out" },
  holiday: { color: "#06B6D4", bg: "#ECFEFF", label: "Company Holiday" },
  absent: { color: "#6B7280", bg: "#F3F4F6", label: "Absent" },
  pending: { color: "#F59E0B", bg: "#FFFBEB", label: "Pending" },
  approved: { color: "#14B8A6", bg: "#ECFDF9", label: "Approved" },
  rejected: { color: "#EF4444", bg: "#FEF2F2", label: "Rejected" },
  bill_submitted: { color: "#3B82F6", bg: "#EFF6FF", label: "Bill Submitted" },
  reimbursed: { color: "#14B8A6", bg: "#ECFDF9", label: "Reimbursed" },
};

const StatusTag = ({ status, label }) => {
  const meta = STATUS_MAP[status] || { color: "#6B7280", bg: "#F3F4F6", label: status || "Unknown" };
  return (
    <Tag
      style={{
        color: meta.color,
        background: meta.bg,
        border: `1px solid ${meta.color}33`,
        fontWeight: 600,
      }}
    >
      <span
        style={{
          display: "inline-block",
          width: 6,
          height: 6,
          borderRadius: "50%",
          background: meta.color,
        }}
      />
      {label || meta.label}
    </Tag>
  );
};

export default StatusTag;
